document.addEventListener("DOMContentLoaded", function () {
  // Check if the screen width is mobile-sized
  if (window.innerWidth <= 749) {
    // Select the title element
    const productTitle = document.querySelector(".product-single__title");
    
    // Select the parent container for the featured image
    const featuredImageWrapper = document.querySelector("#FeaturedImageZoom-product-template-32695508009047-wrapper");

    // Check if both elements exist
    if (productTitle && featuredImageWrapper) {
      // Create a new div container for the title (optional for better styling separation)
      const titleContainer = document.createElement("div");
      titleContainer.classList.add("mobile-title-container");
      titleContainer.appendChild(productTitle);

      // Move the title to be above the featured image
      featuredImageWrapper.parentNode.insertBefore(titleContainer, featuredImageWrapper);
    }
  }
});
